<ng-container *ngIf="user$ | async as user">
  <div class="block mb-3 p-3">
    <div
      class="d-flex justify-content-between flex-wrap align-items-center mb-2"
    >
      <h2 class="block-title">
        {{ "company information" | translate }}
      </h2>
    </div>
    <div class="form-row">
      <div class="form-group col-12 col-md-8 col-lg-6 col-xl-6">
        <label for="">
          {{ "The Company name" | translate }}
        </label>
        <p>
          <strong>
            {{
              user?.creator?.commercialName || user?.creator?.companyName
            }}</strong
          >
        </p>
      </div>
      <div class="form-group col-12 col-md-8 col-lg-6 col-xl-6">
        <label for="">{{ "the address" | translate }}</label>
        <p>
          <strong>
            {{ user?.creator?.address ? user?.creator?.address : "-" }}</strong
          >
        </p>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-12 col-md-8 col-lg-6 col-xl-6">
        <label for="">{{ "CR number" | translate }}</label>
        <p>
          <strong>
            {{ user?.creator?.crNumber ? user?.creator?.crNumber : "-" }}
          </strong>
        </p>
      </div>
      <div class="form-group col-12 col-md-8 col-lg-6 col-xl-6">
        <label for="">{{ "Vat Number" | translate }}</label>
        <p>
          <strong>
            {{ user?.creator?.vatNumber ? user?.creator?.vatNumber : "-" }}
          </strong>
        </p>
      </div>
    </div>
  </div>

  <div class="block mb-3 p-3 taxWrapper" *ngIf="!user?.creator?.vatNumber">
    <div
      class="d-flex justify-content-between flex-wrap align-items-center mb-2"
    >
      <h2 class="block-title">
        {{ "Add Vat Number" | translate }}
      </h2>

      <div>
        <button class="btn btn-primary" (click)="addVatNumber()">
          <i class="fas fa-plus rtl:ml-1 ltr:mr-1"></i>
          {{ "Add" | translate }}
        </button>
      </div>
    </div>
  </div>
  <!-- حفظ سجل ضريبى -->
  <div class="block mb-3 p-3 taxWrapper" *ngIf="user?.creator?.vatNumber">
    <div
      class="d-flex justify-content-between flex-wrap align-items-center mb-2"
    >
      <h2 class="block-title">
        {{ "Vat Number Details" | translate }}
      </h2>

      <div
        *ngIf="
          helpers.isUserAdmin ||
          (helpers.isUserEventCreator && !user?.creator?.vatNumber)
        "
      >
        <button class="btn aboutus-moreBtn" (click)="editVatNumber()">
          <i class="fas fa-pencil-alt text-primary rtl:ml-1 ltr:mr-1"></i>
          {{ "Edit data" | translate }}
        </button>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-12 col-md-8 col-lg-6 col-xl-6">
        <label for="">{{ "Vat Number" | translate }}</label>
        <p>
          <strong> {{ user.creator.vatNumber }} </strong>
        </p>
      </div>
      <div class="form-group col-12 col-md-8 col-lg-6 col-xl-6">
        <label for="">{{ "Certificate" | translate }}</label>
        <p>
          <a [href]="user?.creator?.vatAttachment?.url" target="_blank">{{
            "Download" | translate
          }}</a>
        </p>
      </div>
    </div>
  </div>
  <div class="block mb-3 p-3 taxWrapper" *ngIf="showVatNumberForm">
    <div
      class="d-flex justify-content-between flex-wrap align-items-center mb-2"
    >
      <h2 class="block-title">
        {{
          isEditVatNumber
            ? ("Edit Vat Number" | translate)
            : ("Add Vat Number" | translate)
        }}
      </h2>
    </div>
    <form [formGroup]="vatNumberForm">
      <div class="form-row">
        <div class="form-group col-12 col-md-8 col-lg-6 col-xl-6">
          <app-evento-input
            [eventoFormControl]="vatNumberForm.get('number')"
            requiredMessage="{{ 'Required Field' | translate }}"
            patternMessage="{{ 'Numbers Only Field' | translate }}"
            label="{{ 'Vat Number' | translate }}"
            placeholder="122212223423"
          >
          </app-evento-input>
        </div>
        <div class="form-group col-12 col-md-8 col-lg-6 col-xl-6">
          <app-evento-file-uploader
            label="{{ 'Upload the certificate file' | translate }}"
            [acceptedFiles]="'.pdf'"
            [multiple]="false"
            (fileChanged)="fileSelected($event)"
          ></app-evento-file-uploader>
        </div>
      </div>
    </form>
    <div class="flex space-x-1 rtl:space-x-reverse">
      <button
        class="btn btn-primary"
        (click)="saveVat()"
        [disabled]="!vatNumberForm.valid"
      >
        <i class="fas fa-save align-middle rtl:ml-1 ltr:mr-1"></i>
        {{ "Save" | translate }}
      </button>
      <button class="btn btn-danger" (click)="showVatNumberForm = false">
        <i class="fas fa-times align-middle rtl:ml-1 ltr:mr-1"></i>
        {{ "cancellation" | translate }}
      </button>
    </div>
  </div>
  <!-- اضافة سجل تجارى -->
</ng-container>
